import { WorkTimeSlot } from "modules/calendar-worktime-holiday";

export const getMonday = (date: Date) => {
    const day = date.getDay();
    const diff = (day === 0 ? -6 : 1) - day;
    return new Date(date.setDate(date.getDate() + diff));
};

export const getWeekdayLetter = (date: Date) => {
    const weekDays = ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag"];
    return weekDays[date.getDay() - 1];
};

export const uniqueTimeSlots = (workTimeSlots: WorkTimeSlot[], week: Date[]) => {
    const timeSet = new Set<string>();
    const weekDays = week.slice(0, 5).map(day => getWeekdayLetter(day));

    workTimeSlots.forEach(slot => {
        if (weekDays.includes(slot.day_of_week)) {
            const timeRange = `${slot.start_time.substring(0, 5)} - ${slot.end_time.substring(0, 5)}`;
            timeSet.add(timeRange);
        }
    });

    return Array.from(timeSet).sort();

};

export const isSameDate = (date1: Date, date2: Date) => {
    if (date1.getDate() === date2.getDate() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getFullYear() === date2.getFullYear()) {
        return true
    } else {
        return false
    }

};

export const isPastDateTime = (time: string, currentTime: Date, day: Date) => {
    const [startHour, startMinute] = time.split(" - ")[0].split(":").map(Number);
    const startTime = new Date(day);
    startTime.setHours(startHour, startMinute, 0);
    const isPastDate = currentTime > startTime;
    return isPastDate
}

export const updateWeeks = (offset: number, weeksNumber: number) => {
    const monday = getMonday(new Date());
    const newMonday = new Date(monday);
    newMonday.setDate(monday.getDate() + offset * 7);
    const daysNummber = 7 * weeksNumber
    const newWeek = [];
    for (let i = 0; i < daysNummber; i++) {
      const currentDay = new Date(newMonday);
      currentDay.setDate(newMonday.getDate() + i);
      if (currentDay.getDay() >= 1 && currentDay.getDay() <= 5) {
        newWeek.push(currentDay);
      }
    }
    return newWeek
  };